exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#beta .alert-container .alert.beta-promo{text-align:center;margin-bottom:0;border:2px solid #4571cc;background-color:#4571cc;opacity:.9;color:#fff}#beta .alert-container .alert.beta-promo a{color:#fff;text-align:center;font-weight:700;margin-left:30px}#beta .alert-container .alert.beta-promo a:hover{text-decoration:underline}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/sass-loader!./components/dashboard/dashboard.scss
// module id = 740
// module chunks = 0